export const RECEIVERS_TITLE_TEST_ID = 'receivers-title';
export const RECEIVERS_TABLE_TEST_ID = 'receivers-table';
export const RECEIVERS_TABLE_TOTAL_TEST_ID = 'receivers-table-pagination-total';
export const RECEIVERS_TABLE_ROW_ENTRY_TEST_ID = 'receivers-table-row-entry';

// Details
export const RECEIVERS_DETAILS_TEST_ID = 'receivers-details';
export const RECEIVERS_DETAILS_DELETE_BUTTON_TEST_ID =
  'receivers-details-button-delete';
export const RECEIVERS_DETAILS_CONFIRM_DELETE_BUTTON_TEST_ID =
  'receivers-details-button-delete-confirm';
export const CREATE_RECEIVER_TEST_ID = 'create-receiver';
export const CREATE_RECEIVER_DIALOG_TEST_ID = 'create-receiver-dialog';

// Cancel-confirmation dialog (PEGO-13638)
export const EXIT_UNFINISHED_RECEIVER_TITLE =
  'Exit unfinished receiver creation';
export const EXIT_UNFINISHED_RECEIVER_BODY =
  'Are you sure? Your unsaved changes will be lost.';
export const CREATE_RECEIVER_CONFIRM_DIALOG_TEST_ID =
  'create-receiver-confirm-cancel-dialog';
export const CREATE_RECEIVER_CONFIRM_YES_TEST_ID =
  'create-receiver-confirm-cancel-yes';
export const CREATE_RECEIVER_CONFIRM_NO_TEST_ID =
  'create-receiver-confirm-cancel-no';
